import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'

const styles = theme => ({
  root: {
    position: 'relative',
    width: 'auto',
    float: 'left',
    borderRadius: '4px',
    border: '1px solid #D8D8D8',
    '& button': {
      minHeight: '30px',
      minWidth: 'auto',
      padding: '0 5px',
    },
  },
  paper: {
    position: 'absolute',
    right: 0,
    maxWidth: '250px',
    backgroundColor: theme.colors.midGrey,
    borderRadius: '2px',
    padding: '15px 0',
    zIndex: '1',
    '& div': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: 'auto',
      color: '#6D6E73',
      fontWeight: 350,
      padding: '5px 15px',
      margin: '0 5px',
      textTransform: 'capitalize',
    },
  },
})

class MenuLikePopup extends React.Component {
  state = {
    open: false,
  }

  handleClick = () => {
    this.setState(state => ({
      open: !state.open,
    }))
  }

  handleClickAway = () => {
    this.setState({
      open: false,
    })
  }

  render() {
    const { classes, children, ButtonText } = this.props
    const { open } = this.state

    return (
      <div className={classes.root}>
        <ClickAwayListener onClickAway={this.handleClickAway}>
          <div>
            <Button onClick={this.handleClick} tabIndex="-1" aria-label={ButtonText}>
              {ButtonText}
            </Button>
            {open ? <Paper className={classes.paper}>{children}</Paper> : null}
          </div>
        </ClickAwayListener>
      </div>
    )
  }
}

MenuLikePopup.defaultProps = {
  ButtonText: 'Open',
}
export default withStyles(styles)(MenuLikePopup)
